import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match, RouteComponentProps } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";

import { ListEntregasComp } from "./listmem";
import { EntregaIndex } from "../entrega";

const state = globals.state.map(x => x.viajeApp!);
export class ListEntregas extends React.Component<RouteComponentProps<{ id: string }>> {
    render() {
        return (
            <div>
                <Route
                    exact path={this.props.match.url}
                    render={() => <ListEntregasComp idDireccionDestino={Number.parseInt(this.props.match.params.id)} state={state} onChange={x => globals.setState({viajeApp: x})} /> }
                />
                
                <Route path={this.props.match.url + "/:id"} component={EntregaIndex} />
            </div>
        )
    }
}
 


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entregas/index.tsx